import React from "react";
import "./App.css";
import {
	Route,
	BrowserRouter,
	Routes as Switch,
	Navigate,
} from "react-router-dom";
import { Routes } from "./Helpers/constants";
import Verify from "./Pages/Verify/Verify";
import VerifyEmail from "./Pages/VerifyEmail/VerifyEmail";
import Account from "./Pages/Account/Account";
import { AuthProvider } from "./Providers/AuthProvider";

function App() {
	return (
		<div className="App">
			<AuthProvider>
				<BrowserRouter>
					<Switch>
						<Route
							path={Routes.verify}
							element={<Verify path={Routes.verify} />}
						/>
						<Route path={Routes.verifyEmail} element={<VerifyEmail />} />
						<Route path={Routes.account} element={<Account />} />
						<Route path="*" element={<div>Oops</div>} />
					</Switch>
				</BrowserRouter>
			</AuthProvider>
		</div>
	);
}

export default App;
